<!-- // banner section \\ -->
<section class="banner-section about-banner-section aboutSecOne"
  [className]="isLoggedin ? 'auth_header' : 'unauth_header'">
  <img class="img-responsive aboutMinHeight" src="../../../assets/images/about-us-bg.jpg" alt="about-us-banner" />
  <div class="comman-width">
    <div class="over">
      <h2>About Us</h2>
      <p>
        Helping Americans save on their prescriptions since 2010
      </p>
    </div>
  </div>
</section>
<!-- \\ banner section // -->
<!-- <app-getcard></app-getcard> -->
<section class="RxHacker-section aboutSecTwo">
  <div class="comman-width">
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
        <span class="small-heading">NuLifeSpan Rx Discount was founded in 2010</span>
      </div>
      <div class="clearfix">&nbsp;</div>
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 first-one">
        <h2>Our solution is the NuLifeSpan Rx Discount free NuLifeSpan Rx discount card.</h2>

        <p>The rising cost of healthcare is a major concern for all Americans. From employers to nonprofit organizations
          to each consumer, everyone acknowledges the problems created when spiraling costs force people to choose
          between taking care of their health or paying bills. At NuLifeSpan Rx Discount, we recognize the need for
          affordable
          solutions to the healthcare dilemma; our solution is the NuLifeSpan Rx Discount free NuLifeSpan Rx discount card.
        </p>

        <p>
          We want to extend those savings to as many people as possible. That is why we partner with a variety of
          organizations and healthcare providers:
        </p>
        <ul>
          <li>Pharmacies</li>
          <li>Doctors</li>
          <li>Nonprofit organizations</li>
          <li>Community leaders</li>
          <li>Small businesses</li>
        </ul>
        <span class="rxhacker-text">{{brandName}}</span>

        <span class="rxhacker-line">&nbsp;</span>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 second-one">
        <img class="img-responsive aboutImgResponsive" src="../../../assets/images/hd-founded.jpg" alt="hd-founded" />
      </div>
    </div>
  </div>
</section>
<!-- \\ RxHacker section // -->

<!-- // support section \\ -->
<section class="support-section aboutSecThree">
  <img class="img-responsive aboutMinHeightOur" src="../../../assets/images/our-mission.jpg" alt="our-mission-image" />

  <div class="comman-width">
    <div class="support">
      <h2>Our Mission</h2>
      <p>
        We support our partners’ efforts to better the lives of Americans and
        want to help make each community a better place to live. Our mission is
        to provide affordable prescription healthcare at the lowest cost
        possible. We believe the financial savings that cardholders achieve when
        they use our free NuLifeSpan Rx discount card will have a huge impact on their
        lives and give them access to practical, affordable healthcare
        solutions.
      </p>
    </div>
  </div>
</section>
<!-- \\ support section // -->